import { formatTimeTo12Hour } from "@/lib/utils";
import { formatMakeupDateOnly } from "./makeupDates";
import {
  formatScheduleSlotDateLabel,
  formatScheduleSlotTimeRange,
} from "./scheduleSlotDisplay";

export function formatMakeupTimeRange(
  startTime: string | null | undefined,
  endTime: string | null | undefined,
): string {
  if (!startTime && !endTime) return "-";
  const start = startTime ? formatTimeTo12Hour(startTime) : "-";
  const end = endTime ? formatTimeTo12Hour(endTime) : "-";
  return `${start} – ${end}`;
}

export function formatMakeupSlotLabel(
  date: Date | string | null | undefined,
  startTime?: string | null,
  endTime?: string | null,
  className?: string | null,
): string {
  const dateLabel = formatMakeupDateOnly(date) || "-";
  const timeLabel = formatMakeupTimeRange(startTime, endTime);
  if (className?.trim()) {
    return `${className} · ${dateLabel} · ${timeLabel}`;
  }
  return `${dateLabel} · ${timeLabel}`;
}

export function formatMakeupScheduleSlotLabel(
  start: Date | string,
  end: Date | string,
  className?: string | null,
  timeZone?: string | null,
): string {
  const dateLabel = formatScheduleSlotDateLabel(start, timeZone);
  const timeLabel = formatScheduleSlotTimeRange(start, end, timeZone);
  if (className?.trim()) {
    return `${className} · ${dateLabel} · ${timeLabel}`;
  }
  return `${dateLabel} · ${timeLabel}`;
}
